export default __webpack_public_path__ + "static/media/decorpotOne3.0cf85b67.png";